import { useParams } from "react-router";
import { useClient } from "frontend/src/domain/client";
export var usePageModel = function () {
    var params = useParams();
    return Number(params.id);
};
export var useLoadClient = function () {
    var id = usePageModel();
    useClient(id);
};
